<template>
	<div class="help-detail">
		<Loading v-if="!loading"/>
		<div class="content" v-html="content"></div>
	</div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name:"HelpDetail",
	data(){
		return{
			content:'',
			loading:false,
			imgList:[]
		}
	},
	created(){
		Axios.get('/common/help/detail/'+this.$route.query.id)
		.then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					this.content=response.data.data.content
					this.loading=true
				}
				this.$nextTick(()=>{
					this.imgList=document.querySelector('.content').querySelectorAll("img")
					this.imgList.forEach((item,index)=>{
						item.style.width='100%'
						item.style.height='auto'
						item.style.display='block'
						item.style.margin="10px auto"
					})
				})
			}
		).catch(
			error=>{
				this.$swal({
					text:'网络错误 请稍后重试',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
			}
		)
	},
	components:{
		Loading
	}
}
</script>

<style lang="scss" scoped>
	.help-detail{
		padding:148px 44px 80px 44px; 
		.content{
			font-size:26px;
			color:#222;
			line-height:44px;
		}
	}
</style>